import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMathEquals: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"math-equals, ="} maskId="square-filled-radius-0-stroke-1-IconMathEquals"><path fillRule="evenodd" clipRule="evenodd" d="M4 9H20V10H4V9ZM4 14H20V15H4V14Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMathEquals;
